export const LANDING = '/';
export const ABOUT = '/about';
